export default "__VITE_ASSET__b198bce0__"